// ============================================================
// CONFIGURATION DU SITE — les seuls réglages à personnaliser
// ============================================================

// Adresse qui reçoit les demandes de contact (le formulaire ouvre la
// messagerie du visiteur avec le message pré-rempli vers cette adresse).
export const CONTACT_EMAIL = "yassineabou.contact@gmail.com";

// Liens de paiement Stripe (PRODUCTION) : pages de paiement hébergées par Stripe.
// Deux liens par formule : prélèvement toutes les 4 semaines, ou paiement
// annuel en une fois (4 semaines offertes).
export const PAYMENT_LINKS = {
  autonomie: {
    weeks4: "https://buy.stripe.com/7sYaEZanjfQi3Mb7mm7g406",
    annual: "https://buy.stripe.com/5kQ14p9jfgUmciH2227g40a",
  },
  collectif: {
    weeks4: "https://buy.stripe.com/5kQ8wR0MJeMeeqPfSS7g407",
    annual: "https://buy.stripe.com/7sY9AVgLH33waaz0XY7g409",
  },
  individuel: {
    weeks4: "https://buy.stripe.com/9B66oJ2UR8nQ2I73667g408",
    annual: "https://buy.stripe.com/3cIaEZ9jffQi3Mb0XY7g40b",
  },
};
